import Header from '../../home/components/Header';
import Footer from '../../home/components/Footer';
import PageHero from '../../../components/feature/PageHero';
import { useNavigate } from 'react-router-dom';

const WHATSAPP_URL = 'https://wa.me/5511913278081?text=Ol%C3%A1%2C%20preciso%20de%20atendimento%20jur%C3%ADdico%20urgente.';

const servicos = [
  {
    titulo: 'Flagrante e Delegacia',
    descricao: 'Atendimento imediato em casos de prisão em flagrante, oferecendo acompanhamento completo desde o momento da prisão até os desdobramentos na delegacia. Atuamos de forma ágil e estratégica para assegurar que todos os seus direitos sejam respeitados desde o primeiro contato com as autoridades. Também atuamos em casos de intimação policial, orientando e acompanhando o cliente em todas as etapas, com foco na proteção de seus direitos e na melhor condução do caso.',
  },
  {
    titulo: 'Audiência de Custódia',
    descricao: 'Atuação técnica na audiência de custódia para questionar a legalidade da prisão, combater abusos e pleitear a liberdade provisória ou a aplicação de medidas cautelares alternativas à prisão.',
  },
  {
    titulo: 'Defesa Criminal',
    descricao: 'Atuação estratégica e altamente especializada na construção de teses defensivas robustas, com acompanhamento minucioso em todas as fases do processo penal — da resposta à acusação à audiência de instrução, alegações finais e julgamento —, sempre orientada por estratégia individualizada e sólida fundamentação jurídica.',
  },
  {
    titulo: 'Acompanhamento de Inquérito',
    descricao: 'Atuação estratégica na fase de investigação, com acompanhamento desde o início do inquérito policial, incluindo o controle das diligências, análise dos elementos do caso e definição antecipada das estratégias de defesa, sempre com foco na proteção dos direitos do investigado e na preparação sólida para a fase judicial.',
  },
  {
    titulo: 'Tribunal do Júri',
    descricao: 'Defesa especializada em crimes dolosos contra a vida, com atuação no plenário do júri. Preparação detalhada da defesa, dos quesitos e das sustentações orais para garantir o melhor resultado ao réu.',
  },
  {
    titulo: 'Habeas Corpus',
    descricao: 'Impetração de habeas corpus preventivo ou liberatório para combater prisões ilegais, excessivas ou sem fundamentação adequada, garantindo o direito à liberdade do cliente com a máxima agilidade.',
  },
  {
    titulo: 'Execução Penal',
    descricao: 'Acompanhamento na execução da pena: progressão de regime, livramento condicional, saídas temporárias, remição de pena e demais incidentes de execução, assegurando todos os direitos do apenado.',
  },
  {
    titulo: 'Revisão Criminal',
    descricao: 'Análise e propositura de ação de revisão criminal quando existem elementos novos ou comprovação de erro judiciário, buscando a desconstituição de condenações injustas ou inadequadas.',
  },
  {
    titulo: 'Recursos Criminais',
    descricao: 'Interposição e acompanhamento de recursos em todas as instâncias — apelação, RESE, embargos de declaração, agravo em execução e recursos para tribunais superiores.',
  },
];

export default function CriminalPage() {
  const navigate = useNavigate();

  return (
    <main className="font-sans">
      <Header />
      <PageHero
        tag="Área de Atuação"
        titulo="Direito"
        tituloItalico="Criminal"
        subtitulo="Defesa técnica e estratégica em todas as fases do processo criminal. Do flagrante ao tribunal, com dedicação total à proteção dos seus direitos."
      />

      {/* Intro */}
      <section className="py-[60px] bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#B39B62]"></span>
            <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
              Nossa atuação
            </span>
          </div>
          <h2 className="font-serif text-3xl lg:text-4xl text-[#0A1829] font-light leading-snug mb-6">
            Defesa criminal com <span className="italic text-[#B39B62]">rigor e estratégia</span>
          </h2>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-4">
            O Direito Penal é uma das áreas mais sensíveis do ordenamento jurídico brasileiro. Uma acusação criminal pode comprometer a liberdade, o patrimônio e a reputação de qualquer pessoa — independentemente de culpa. Por isso, contar com uma defesa técnica sólida desde o primeiro momento é fundamental.
          </p>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-4">
            No escritório Moreira Tófoli Advogados, a defesa criminal é conduzida a partir de uma análise minuciosa de cada caso, com definição de estratégias processuais adequadas e atuação firme e consistente em todas as instâncias — desde a fase investigativa até os tribunais superiores.
          </p>
          <p className="font-sans text-[#0A1829]/70 text-base leading-relaxed mb-3">
            Atuamos tanto em situações de urgência, como prisões em flagrante e audiências de custódia, quanto em demandas de maior complexidade e duração, como recursos e revisões criminais, sempre com o mesmo padrão de excelência técnica e cuidado humano com o cliente e sua família.
          </p>
          <div className="flex items-center gap-6 pt-4 border-t border-[#E9D59C]/40">
            <div className="text-center">
              <div className="font-serif text-2xl text-[#B39B62] font-light">24h</div>
              <div className="font-sans text-xs text-[#0A1829]/50 tracking-wide uppercase mt-1">Atendimento</div>
            </div>
            <div className="h-10 w-px bg-[#E9D59C]/50"></div>
            <div className="text-center">
              <div className="font-serif text-2xl text-[#B39B62] font-light">100%</div>
              <div className="font-sans text-xs text-[#0A1829]/50 tracking-wide uppercase mt-1">Dedicação</div>
            </div>
            <div className="h-10 w-px bg-[#E9D59C]/50"></div>
            <div className="text-center">
              <div className="font-serif text-2xl text-[#B39B62] font-light">Sigilo</div>
              <div className="font-sans text-xs text-[#0A1829]/50 tracking-wide uppercase mt-1">Absoluto</div>
            </div>
          </div>
        </div>
      </section>

      {/* Serviços */}
      <section className="py-[60px] bg-[#F8F5EE]">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-6">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="h-px w-12 bg-[#B39B62]"></span>
              <span className="text-[#B39B62] text-xs font-sans font-semibold tracking-[0.2em] uppercase">
                Serviços incluídos – Criminal
              </span>
              <span className="h-px w-12 bg-[#B39B62]"></span>
            </div>
            <h2 className="font-serif text-3xl lg:text-4xl text-[#0A1829] font-light">
              O que <span className="italic text-[#B39B62]">abrangemos</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {servicos.map((s) => (
              <div key={s.titulo} className="bg-white border border-[#E9D59C]/40 rounded-lg p-6 hover:-translate-y-1 transition-transform duration-300">
                <h3 className="font-serif text-base text-[#0A1829] font-medium mb-2">{s.titulo}</h3>
                <p className="font-sans text-[#0A1829]/55 text-xs leading-relaxed">{s.descricao}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-[60px] bg-[#0A1829] text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="font-serif text-3xl lg:text-4xl text-white font-light mb-4">
            Precisa de <span className="italic text-[#E9D59C]">defesa criminal?</span>
          </h2>
          <p className="font-sans text-white/55 text-base leading-relaxed mb-3">
            Em situações urgentes como flagrante, prisão ou recebimento de intimação, cada minuto conta. Entre em contato imediatamente.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-[#B39B62] hover:bg-[#E9D59C] text-[#0A1829] font-sans font-semibold text-base px-10 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Atendimento imediato
            </a>
            <a
              href="/atuacao"
              onClick={(e) => { e.preventDefault(); navigate('/atuacao'); }}
              className="inline-flex items-center justify-center gap-2 border border-white/30 text-white hover:border-[#B39B62] hover:text-[#B39B62] font-sans font-medium text-base px-8 py-4 rounded-md transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Ver todas as áreas
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
